import React from "react";
import { overview, aboutBlock } from "../mock";
import { Reveal } from "../hooks/useReveal";

export default function Overview() {
  return (
    <section id="about" className="bg-[var(--cream)]" style={{ backgroundColor: "var(--cream)" }}>
      <div className="max-w-[1500px] mx-auto px-6 md:px-10 py-24 md:py-36">
        <div className="grid md:grid-cols-[0.85fr_1.15fr] gap-14 md:gap-20 items-start">
          <Reveal>
            <p className="font-sans-ui tracking-wide-2 text-[0.66rem] uppercase mb-8" style={{ color: "var(--teal)" }}>
              {overview.eyebrow}
            </p>
            <p className="font-script text-4xl md:text-5xl" style={{ color: "var(--sand)" }}>
              {overview.script}
            </p>
          </Reveal>

          <Reveal delay={120}>
            <h2 className="font-serif-display text-[2.4rem] md:text-[3.6rem] leading-[1.08] font-300 text-[var(--navy)]" style={{ color: "var(--navy)" }}>
              {overview.headline}
            </h2>
            <p className="mt-8 text-[var(--muted)] text-base md:text-lg leading-relaxed max-w-2xl" style={{ color: "var(--muted)" }}>
              {overview.body}
            </p>

            <div className="mt-12 flex flex-wrap gap-x-10 gap-y-3">
              {aboutBlock.keywords.map((k) => (
                <span key={k} className="font-serif-display text-2xl md:text-3xl text-[var(--navy)]/80" style={{ color: "rgba(22,50,79,0.8)" }}>
                  {k}
                </span>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
